module.exports = __webpack_public_path__ + "media/images/drivers-fill-topbar-06afd484683d624e7a022db3c9fa2219.svg";